export const TOGGLE_MAP = 'toggle-map';
const toggleMap = () => ({ type: TOGGLE_MAP });
export default toggleMap;
